import {
	Component,
	Input,
	ContentChild,
	TemplateRef,
	EventEmitter,
	ChangeDetectionStrategy,
	Output,
} from "@angular/core";

@Component({
	selector: "ic-image",
	templateUrl: "./image.component.html",
	styleUrls: ["./image.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ImageComponent {
	// @ts-expect-error TS2564
	@Input() src: string;
	// @ts-expect-error TS2564
	@Input() alt: string;
	@Input() loading: "lazy" | "eager" = "lazy";
	@Input() errorText?: string;

	@Output() errorOnImage = new EventEmitter<void>();

	// @ts-expect-error TS2564
	@ContentChild("errorTemplate") errorTemplate: TemplateRef<any>;

	showFallback = false;

	onError() {
		this.showFallback = true;
		this.errorOnImage.emit();
	}
}
